import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { ScrollableDrawer, Stack } from '@emburse/embark-core';
import { $t, useTranslation } from '../../../hooks/useTranslation';
import { AuditAlertsContext } from '../AuditAlertsProvider';
import AlertsDrawerFlag from './AlertsDrawerFlag';
import AlertsDrawerHeader from './AlertsDrawerHeader';
import AlertsDrawerDetails from './AlertsDrawerDetails';
export default function AlertsDrawer() {
    useTranslation();
    const { sidebarOpen, toggleSidebar, selectedAuditExpense } = useContext(AuditAlertsContext);
    return (_jsx(ScrollableDrawer, { header: $t('Expense Details'), open: sidebarOpen && !!selectedAuditExpense, openUpdated: toggleSidebar, anchor: "right", sideWidth: 448, "data-qa": "alerts-drawer", children: _jsxs(Stack, { alignItems: "flex-start", sx: { width: '100%' }, spacing: 3, children: [_jsx(AlertsDrawerHeader, {}), !!selectedAuditExpense &&
                    selectedAuditExpense.Flags.map((auditFlag) => (_jsx(AlertsDrawerFlag, { auditFlag: auditFlag }, auditFlag.AuditFlagPK))), _jsx(AlertsDrawerDetails, {})] }) }));
}
